import StudentDebtPage from './StudentDebtPage';
export default StudentDebtPage;
